module.exports = __webpack_public_path__ + "static/media/walletWhite.8ecd3c08.svg";